<template>
    <div class="Administration">
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="交易报告" name="first">
                <transactionReport></transactionReport>
            </el-tab-pane>
            <!-- --------------------------交易明细 ----------------------- -->
            <el-tab-pane label="交易明细" name="second">
                <transactionDetail></transactionDetail>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
// 交易报告
import transactionReport from './transactionReport.vue';
// 交易明细
import transactionDetail from './transactionDetail.vue';

export default {
    components: {
        transactionReport,
        transactionDetail
    },
    name: "AmazonSettlement",
    data() {
        return {
            activeName: "first"
        };
    },
    methods: {
    }
};
</script>

<style lang="scss" scoped></style>